import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';

@Component({
  selector: 'app-privacy',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {
  private firestore = inject(Firestore);
  privacyContent = 'Loading...';

  async ngOnInit() {
    try {
      const docRef = doc(this.firestore, 'photobooth_config_published', 'legal');
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        this.privacyContent = docSnap.data()['privacyPolicy'] || 'No Privacy Policy content found.';
      } else {
        this.privacyContent = 'Privacy Policy document not found in database.';
      }
    } catch (err) {
      console.error('Error fetching privacy policy:', err);
      this.privacyContent = 'Failed to load Privacy Policy.';
    }
  }
}
